import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import t from "@zendesk/client-i18n-tools";
import AutocompleteList from "../../../AutocompleteList";
import { STAFF, SIGNED_IN_USERS } from "../../../../constants";
import * as actions from "../../../../actions/userSegment";
import styles from "./index.css";

export class SegmentStep extends Component {
  componentWillMount() {
    const { fetchUsers } = this.props;
    fetchUsers();
  }

  render() {
    const {
      userType,
      tags,
      groups,
      organizations,
      addOrganization,
      addGroup,
      addTag,
    } = this.props;

    return (
      <div className={styles.stepBody} data-test-id="step-body">
        <h2 className={styles.stepTitle}>
          {userType === STAFF
            ? t("knowledge-user-segments.wizard.segmentStaffTitle")
            : t("knowledge-user-segments.wizard.segmentSignedInUsersTitle")}
        </h2>
        <div>
          <h2 className={styles.resrtrictionsTitle}>
            {t("knowledge-user-segments.userSegment.matchTheFollowing")}
          </h2>

          <AutocompleteList
            isLoading={false}
            items={tags}
            type="tags"
            newText={t("knowledge-user-segments.userSegment.addTag")}
            conjunction={t(
              "knowledge-user-segments.userSegment.conjunctionAnd"
            )}
            onAddNew={addTag}
            title={t("knowledge-user-segments.userSegment.tags")}
            description={t(
              "knowledge-user-segments.userSegment.tagsDescription",
              {
                learnMoreUrl: t(
                  "knowledge-user-segments.userSegment.tagsDescriptionLearnMoreUrl"
                ),
              }
            )}
          />

          {userType === SIGNED_IN_USERS && (
            <AutocompleteList
              isLoading={false}
              items={organizations}
              type="organizations"
              newText={t("knowledge-user-segments.userSegment.addOrganization")}
              conjunction={t(
                "knowledge-user-segments.userSegment.conjunctionOr"
              )}
              onAddNew={addOrganization}
              title={t("knowledge-user-segments.userSegment.organizations")}
              description={t(
                "knowledge-user-segments.userSegment.organizationsDescription",
                {
                  learnMoreUrl: t(
                    "knowledge-user-segments.userSegment.organizationsDescriptionLearnMoreUrl"
                  ),
                }
              )}
            />
          )}

          {userType === STAFF && (
            <AutocompleteList
              isLoading={false}
              items={groups}
              type="groups"
              newText={t("knowledge-user-segments.userSegment.addGroup")}
              conjunction={t(
                "knowledge-user-segments.userSegment.conjunctionOr"
              )}
              onAddNew={addGroup}
              title={t("knowledge-user-segments.userSegment.groups")}
              description={t(
                "knowledge-user-segments.userSegment.groupsDescription",
                {
                  learnMoreUrl: t(
                    "knowledge-user-segments.userSegment.groupsDescriptionLearnMoreUrl"
                  ),
                }
              )}
            />
          )}
        </div>
      </div>
    );
  }
}

SegmentStep.propTypes = {
  userType: PropTypes.oneOf([STAFF, SIGNED_IN_USERS]),
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  organizations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  fetchUsers: PropTypes.func,
  addOrganization: PropTypes.func,
  addGroup: PropTypes.func,
  addTag: PropTypes.func,
};

SegmentStep.defaultProps = {
  tags: [],
  groups: [],
  organizations: [],
};

const mapStateToProps = ({ userSegment }, { type }) => ({
  userType: userSegment.userType,
  tags: userSegment.tags,
  groups: userSegment.groups,
  organizations: userSegment.organizations,
});

const mapDispatchToProps = (dispatch, { type }) =>
  bindActionCreators({ ...actions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SegmentStep);



// WEBPACK FOOTER //
// ./src/components/NewUserSegment/components/SegmentStep/index.js